import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography'
import { all } from '../../../app/data/validate';
import SectionSettings from './SectionSettings';
import Spacer from '../../../app/common/ui/Spacer';
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'

const SettingsContent = ({ config, onChange, onSave }) => {

    const [changed, setChanged] = useState(false);

    const settings = Object.entries(config)
        .filter(([_, attributes]) => all(attributes.value, attributes.type, attributes.description))
        .map(([field, attributes]) => {
            return {
                field,
                attributes
            }
        });
    const sections = new Map();

    settings.forEach(item => {
        const key = item.attributes.section;
        sections.set(key, [item, ...(sections.get(key) ?? [])])
    });

    const handleChange = setting => {
        setChanged(true);
        onChange(setting);
    }

    const handleSave = () => {
        setChanged(false);
        onSave();
    }

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item>
                    <Typography variant="h4" color="initial">System Settings</Typography>
                </Grid>
                <Grid item>
                    {
                        changed &&
                        <Button onClick={handleSave}
                            variant="contained" color="secondary">
                            Apply Changes
                        </Button>
                    }
                </Grid>
            </Grid>
            <Spacer />
            {
                Array.from(sections.keys()).sort((a, b) => a.localeCompare(b)).map(key => {
                    return <React.Fragment key={key}>
                        <SectionSettings section={key} settings={sections.get(key)} onChange={handleChange} />
                        <Spacer />
                    </React.Fragment>
                })
            }
        </div>
    );
};

export default SettingsContent;